import * as React from 'react';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'app/pages/AgentSearch/actionTypes';
import { AgentSearchStatus, AgentListItem } from 'app/pages/AgentSearch/modules/AgentItemsList/state';
import { getAgents, getSearchStatus, getSearchTerm } from 'app/pages/AgentSearch/modules/AgentItemsList';
import AgentItem from 'app/pages/AgentSearch/components/AgentItem';
import { SearchOutlined } from '@ant-design/icons';
import { Alert, Pagination, theme } from 'antd';
import { ListLayout, ListLayoutItem } from 'app/shared/ui/ListLayout';

export interface AgentItemsListProps {}

interface StateProps {
    hasSearchTerm: boolean,
    agents: AgentListItem[],
    status: AgentSearchStatus
}

interface DispatchProps { }

type InternalProps = StateProps & DispatchProps;

const PAGE_SIZE = 10;
const { useToken } = theme;

function renderMessage(props: InternalProps) {
    if (props.status === AgentSearchStatus.Errored) {
        return (
            <Alert
                title="We're sorry"
                description="An error occurred when running the agent search, please try again."
                type="error"
                showIcon
                style={{ marginBottom: '16px', marginTop: '16px' }}
            />
        );
    }

    if (props.status === AgentSearchStatus.Success && props.agents.length == 0) {
        if (props.hasSearchTerm) {
            return (
                <Alert
                    title="No results"
                    description="There were no results found that matched your search criteria."
                    type="info"
                    showIcon
                    style={{ marginBottom: '16px', marginTop: '16px' }}
                />
            );
        } else {
            return (
                <Alert
                    title="Start searching"
                    description="Please start typing the name of the required agent in the search box."
                    type="info"
                    showIcon
                    icon={<SearchOutlined />}
                    style={{ marginBottom: '16px', marginTop: '16px' }}
                />
            );
        }
    }
}

const AgentItemsList = (props: InternalProps) => {
    const { token } = useToken();
    const [currentPage, setCurrentPage] = React.useState(1);

    React.useEffect(() => {
        setCurrentPage(1);
    }, [props.agents]);

    const showList = props.agents.length > 0 && props.status !== AgentSearchStatus.Errored;
    const paginatedAgents = showList
        ? props.agents.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE)
        : [];

    return (
        <>
            {renderMessage(props)}
            {showList && (
                <>
                    <ListLayout>
                        {paginatedAgents.map((agent) => (
                            <ListLayoutItem key={agent.id}>
                                <AgentItem agent={agent} />
                            </ListLayoutItem>
                        ))}
                    </ListLayout>
                    {props.agents.length > PAGE_SIZE && (
                        <div style={{ textAlign: 'center', marginTop: token.marginLG }}>
                            <Pagination
                                current={currentPage}
                                pageSize={PAGE_SIZE}
                                total={props.agents.length}
                                onChange={setCurrentPage}
                                showSizeChanger={false}
                            />
                        </div>
                    )}
                </>
            )}
        </>
    );
};

const mapStateToProps = (state:any, ownProps: AgentItemsListProps) : StateProps => {
    const searchTerm = getSearchTerm(state);
    return {
        hasSearchTerm: searchTerm !== '',
        agents: getAgents(state),
        status: getSearchStatus(state)
    };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>, ownProps: AgentItemsListProps) : DispatchProps => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(AgentItemsList);
